import Cartao from '@/components/ui/Cartao';
import Botao from '@/components/ui/Botao';
import { NumeroFita } from '@/pages/gerenciar/components/TilePainel';
import type { CaixaFinanceiro } from './tipos';
import { conta, reais } from './rotulos';
import Info from './Info';

function BlocoValor({
  rotulo,
  valor,
  dica,
}: {
  rotulo: string;
  valor: string;
  dica: string;
}) {
  return (
    <div className="min-w-0 rounded-2xl bg-background-50 p-3">
      <span className="flex items-center gap-1 text-[13px] text-foreground-500">
        {rotulo}
        <Info texto={dica} />
      </span>
      <NumeroFita
        valor={valor}
        base="text-[clamp(17px,5.4vw,26px)] md:text-[clamp(20px,1.8vw,28px)]"
        className="mt-2 min-w-0 text-foreground-950"
      />
    </div>
  );
}

export default function BlocoCaixa({
  caixa,
  aoLancarEntrada,
  aoLancarDespesa,
}: {
  caixa: CaixaFinanceiro;
  aoLancarEntrada: () => void;
  aoLancarDespesa: () => void;
}) {
  return (
    <Cartao className="p-4">
      <h2 className="text-[17px] font-bold text-foreground-950">Caixa e despesas</h2>

      <div className="mt-3 grid gap-3 sm:grid-cols-2">
        <BlocoValor
          rotulo="Dinheiro na gaveta"
          valor={reais(caixa.em_caixa_dinheiro)}
          dica="dinheiro recebido no caixa e lançado à mão, menos despesas pagas em dinheiro"
        />
        <BlocoValor
          rotulo="Disponível no total"
          valor={reais(caixa.disponivel_total)}
          dica="líquido + outras entradas − despesas"
        />
      </div>

      <div className="mt-3 flex flex-wrap gap-x-4 gap-y-1 text-[13px] text-foreground-700">
        <span>
          Outras entradas {reais(caixa.entradas_avulsas)} ({conta(caixa.entradas_avulsas_n)})
        </span>
        <span>
          Despesas {reais(caixa.despesas)} ({conta(caixa.despesas_n)})
        </span>
      </div>

      <div className="mt-4 flex flex-col gap-2 sm:flex-row">
        <Botao variante="secundario" icone="ri-add-line" cheio onClick={aoLancarEntrada}>
          Lançar entrada
        </Botao>
        <Botao variante="perigo-contorno" icone="ri-subtract-line" cheio onClick={aoLancarDespesa}>
          Lançar despesa
        </Botao>
      </div>
    </Cartao>
  );
}